import React, { } from 'react';
import { NewsMediaAssetContainer } from '../../containers/news/NewsMediaAssetContainer';
import { logNewsEvent } from '../../services/news';

/** The navigation of the Media Assets Page */
export const NewsMediaPage = () => {
    logNewsEvent("Media");
    return <NewsMediaAssetContainer />;
}




